// Loading styles
import '../styles/main.scss';
// Loading scripts
//import './font-awesome.config';

import ElementorImageGallery from "./inc/ElementorImageGallery";
import FilterPosts from "./inc/FilterPosts";
import HeaderSearch from "./inc/HeaderSearch";
import MobileFilter from "./inc/MobileFilter";
import PlusTabs from "./inc/PlusTabs";
import PressAgenda from "./inc/PressAgenda";
import TwitterFeeds from "./inc/TwitterFeeds";
import MobileMenu from "./inc/MobileMenu";

// Launch when DOM is ready.
window.addEventListener('DOMContentLoaded', () => {
  // mark no-js class as js because JS is working.
  document.documentElement.classList.replace('no-js', 'js');

  new ElementorImageGallery();
  new FilterPosts();
  new HeaderSearch();
  new MobileFilter();
  new PlusTabs();
  new PressAgenda();
  new TwitterFeeds();
  new MobileMenu('.firac-mobile-menu__menus__menu');
});
